import * as jetpack from "fs-jetpack";
import { string } from "../helpers";

export type HotchFSCopyCommandOptionProps = {};

export interface HotchFSCopyCommandProps {
  from: string;
  to: string;
  options: HotchFSCopyCommandOptionProps;
}

export const copy = async (props: HotchFSCopyCommandProps) => {
  const { from, to, options } = props;
  try {
    return await jetpack.copyAsync(from, to, options);
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const copySync = (props: HotchFSCopyCommandProps) => {
  const { from, to, options } = props;
  try {
    return jetpack.copy(from, to, options);
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const inspectTree = async (props: { path: string; options: {} }) => {
  try {
    return await jetpack.inspectTree(props.path, {
      checksum: "md5",
      times: true,
      relativePath: false,
      symlinks: "report",
      ...props.options,
    });
  } catch (e) {
    console.log(e);
    throw e;
  }
};

// export const copy = async () => {
//   try {
//   } catch (e) {
//     console.log(e);
//     throw e;
//   }
// };

// export const copy = async () => {
//   try {
//   } catch (e) {
//     console.log(e);
//     throw e;
//   }
// };

// export const copy = async () => {
//   try {
//   } catch (e) {
//     console.log(e);
//     throw e;
//   }
// };

// export const copy = async () => {
//   try {
//   } catch (e) {
//     console.log(e);
//     throw e;
//   }
// };

// export const copy = async () => {
//   try {
//   } catch (e) {
//     console.log(e);
//     throw e;
//   }
// };

// export const copy = async () => {
//   try {
//   } catch (e) {
//     console.log(e);
//     throw e;
//   }
// };

// export const copy = async () => {
//   try {
//   } catch (e) {
//     console.log(e);
//     throw e;
//   }
// };
